module.exports = __webpack_public_path__ + "static/media/808ColumnLabel--3.61e2f796.svg";